import { css } from '@compiled/react';
import { token } from '@atlaskit/tokens';
import Warning from '@atlaskit/icon/glyph/warning';

export const SectionFeedback = ({ description }: { description: string }) => {
  return (
    <div css={containerStyles}>
      <Warning
        label="Warning"
        size="medium"
        primaryColor={token('color.icon.subtle')}
      />
      <p css={descriptionStyles}>{description}</p>
    </div>
  );
};

const containerStyles = css({
  maxWidth: '474px',
  padding: `${token('space.300')} 0`,
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  gap: '12px',
});

const descriptionStyles = css({
  color: token('color.text.subtle'),
  fontSize: '16px',
  lineHeight: '24px',
  fontWeight: '400',
  margin: '0',
});
